<template>
    <div class="pagebox">

        <!-- 顶部 -->
        <PHeader></PHeader>

        <!-- 内容 -->
        <div class="noticediv">
            <div class="noticecon">
                <div class="txt" v-html="ContentData.RichTextContent"></div>
            </div>
        </div>

        <!-- 底部 -->
        <PFooter></PFooter>

    </div>
</template>
<script>
import PHeader from "@/components/Header.vue";
import PFooter from "@/components/Footer.vue";
import API from "@/api/config";
export default{
    components:{
        PHeader,
        PFooter
    },
    data(){
        return{
            ContentData:{
                RichTextContent:''
            }
        }
    },
    mounted(){
        API.Web.GetContentDetail({contentKey:this.$route.query.key}).then(res => {
            if(res.Code===0&&res.Data!=null){
                this.ContentData = res.Data;

                if (res.Data.ContentName) {

                    let seoInfo = localStorage.getItem('WebSEO')

                    if (seoInfo) {
                        seoInfo = JSON.parse(seoInfo) || []

                        let configTitle = ''

                        seoInfo.some(item => {
                            if (item.ParamKey === "WebSEO_Name") {
                                configTitle = item.ParamValue

                                document.title = `${configTitle}-${res.Data.ContentName}`

                                return true
                            }
                        })
                    }
                }
            }
        });
    }
}
</script>
<style lang="less" scoped>
.noticediv{
    max-width: 1200px;
    margin: auto;
    .noticecon{
        margin: 30px 20px 30px;
        border: 1px solid #ddd;
        min-height: 600px;
        background-color: #fff;
        .tit{
            color: #444;
            font-size: 20px;
            line-height: 30px;
            margin: 20px 20px 0;
            text-align: center;
            font-weight: bold;
        }
        .time{
            text-align: center;
            color: #666;
            font-size: 14px;
            margin-top: 10px;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;
        }
        .txt{
            color: #555;
            font-size: 14px;
            line-height: 24px;
            text-indent: 28px;
            margin: 20px 30px 30px;
            img,video,p img,p video{
                width: auto;
                max-width: 100%;
                display: block;
                margin:auto;
            }
            div video{
                width: 100%;
            }
        }
    }
}
</style>